import React from 'react';
import { childAbuseHTML } from '../static/childAbuse';

const ChildAbuse = () => {
  return (
    <div style={{ width: "100%", overflowX: "hidden" }} dangerouslySetInnerHTML={{ __html: childAbuseHTML(`${process.env.PUBLIC_URL}/images/mini-logo.png`) }}></div>
  )
}

export default ChildAbuse;